var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c(
          "div",
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: { loading: _vm.loading, color: _vm.color },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.stores
        ? _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Склад отправитель:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.invoice.store_out,
                            expression: "invoice.store_out",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { disabled: _vm.selectDisable },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.invoice,
                                "store_out",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.updateReceiverStore,
                          ],
                        },
                      },
                      _vm._l(_vm.stores, function (store, index) {
                        return _c("option", { domProps: { value: store.id } }, [
                          _vm._v(_vm._s(store.title)),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.invoice.store_out
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Склад получатель:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.invoice.store_in,
                                expression: "invoice.store_in",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { disabled: _vm.selectDisable },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.invoice,
                                    "store_in",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                _vm.updateDeliveryDate,
                              ],
                            },
                          },
                          _vm._l(
                            _vm.stores[_vm.invoice.store_out].allowToSend
                              .sub_value,
                            function (store, id) {
                              return _vm.stores[_vm.invoice.store_out]
                                ? _c("option", { domProps: { value: id } }, [
                                    _vm._v(_vm._s(_vm.stores[id].title)),
                                  ])
                                : _vm._e()
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Дата накладной:"),
                      ]),
                      _vm._v(" "),
                      _c("datetime", {
                        attrs: {
                          "input-class": "form-control",
                          type: "datetime",
                          "minute-step": 60,
                          format: "dd.MM.yyyy HH:mm",
                          auto: true,
                          "min-datetime": _vm.minDateSelect,
                        },
                        model: {
                          value: _vm.invoice.delivery_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.invoice, "delivery_date", $$v)
                          },
                          expression: "invoice.delivery_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Комментарий:"),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoice.comment,
                          expression: "invoice.comment",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { rows: "2" },
                      domProps: { value: _vm.invoice.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.invoice, "comment", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 btn_div" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.createInvoice },
                      },
                      [_vm._v("Создать")]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.invoiceDetailsVisibility
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  [
                    _c("invoiceDetails", {
                      ref: "invoiceDetails",
                      attrs: {
                        invoiceType: _vm.invoiceType,
                        invoice: _vm.invoice,
                        storeId: _vm.invoice.store_out,
                        updateDiscount: _vm.updateDiscount,
                        useCurrency: false,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "row" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5" }, [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.invoice.discount,
                                expression: "invoice.discount",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: { value: _vm.invoice.discount },
                            on: {
                              change: _vm.updateDiscount,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.invoice,
                                  "discount",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-radio" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoice.discount_type,
                                    expression: "invoice.discount_type",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "radio",
                                  id: "customRadio1",
                                  value: "1",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.invoice.discount_type,
                                    "1"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.invoice,
                                        "discount_type",
                                        "1"
                                      )
                                    },
                                    _vm.updateDiscount,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "customRadio1" },
                                },
                                [
                                  _vm._v(
                                    "Общая сумма в валюте накладной (скидка "
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.discountInPercent) + "%"),
                                  ]),
                                  _vm._v(")"),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "custom-control custom-radio" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoice.discount_type,
                                    expression: "invoice.discount_type",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "radio",
                                  id: "customRadio2",
                                  value: "2",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.invoice.discount_type,
                                    "2"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.invoice,
                                        "discount_type",
                                        "2"
                                      )
                                    },
                                    _vm.updateDiscount,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "customRadio2" },
                                },
                                [_vm._v("Процент с каждой позиции")]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v("Общая сумма накладной без скидки: "),
                            _c("strong", [_vm._v(_vm._s(_vm.printTotalSum()))]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Общая сумма накладной со скидкой: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.printTotalSum(true))),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.invoice.discount
                        ? _c("div", { staticClass: "col-md-3" }, [
                            _c("p", [
                              _vm._v("Реальная скидка: "),
                              _c("strong", [_vm._v(_vm._s(_vm.realDiscount))]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Реальный %: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.realDiscountInPercent)),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _vm.invoiceStatuses
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.invoice.status,
                                expression: "invoice.status",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.invoice,
                                  "status",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.invoiceStatuses, function (title, id) {
                            return _c("option", { domProps: { value: id } }, [
                              _vm._v(_vm._s(title)),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !_vm.invoiceSaved
                    ? _c(
                        "div",
                        { staticClass: "col-md-6 text-right" },
                        [
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-success",
                                "data-style": "zoom-in",
                                loading: _vm.btn_save_loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.saveNewInvoice()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "Сохранить новую накладную\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Накладная перемещения")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }